import axios from '@/plugins/axios';

export const getUserPlannerEvents = async (userId, { from, to }) => {
  const { data } = await axios.get(`/planeador-asesor/${userId}/overview`, {
    params: { from, to },
  });

  return data?.data;
};
